import { toast } from "react-toastify";
import { ResourceConstants } from "../constants";
import { resourceService } from "../services";

const createUser = (userdata) => {
  const request = (userdata) => {
    return { type: ResourceConstants.CREATERESOURCEUSER_REQUEST, userdata };
  };
  const success = (user) => {
    return { type: ResourceConstants.CREATERESOURCEUSER_SUCCESS, user };
  };
  const failure = (error) => {
    return { type: ResourceConstants.CREATERESOURCEUSER_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(userdata));
    return resourceService.createUser(userdata).then(
      (user) => {
        // toast.success("User create successfully");
        dispatch(success(user));
        return user;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
        return false;
      }
    );
  };
};

const createResource = (resourceData) => {
  const request = (resourceData) => {
    return { type: ResourceConstants.CREATERESOURCE_REQUEST, resourceData };
  };
  const success = (resource) => {
    return { type: ResourceConstants.CREATERESOURCE_SUCCESS, resource };
  };
  const failure = (error) => {
    return { type: ResourceConstants.CREATERESOURCE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(resourceData));
    return resourceService.createResource(resourceData).then(
      (resource) => {
        toast.success("Resource created");
        dispatch(success(resource));
        return resource;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
        return false;
      }
    );
  };
};

const updateResource = (resourceData, id) => {
  const request = (resourceData) => {
    return { type: ResourceConstants.UPDATERESOURCE_REQUEST, resourceData };
  };
  const success = (resource) => {
    return { type: ResourceConstants.UPDATERESOURCE_SUCCESS, resource };
  };
  const failure = (error) => {
    return { type: ResourceConstants.UPDATERESOURCE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(resourceData));
    return resourceService.updateResource(resourceData, id).then(
      (resource) => {
        toast.success("Resource updated");
        dispatch(success(resource));
        return resource;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
        return false;
      }
    );
  };
};

const updateResourceStatus = (statusData, id) => {
  const request = (statusData) => {
    return { type: ResourceConstants.RESOURCESTATUSCHANGE_REQUEST, statusData };
  };
  const success = (resource) => {
    return { type: ResourceConstants.RESOURCESTATUSCHANGE_SUCCESS, resource };
  };
  const failure = (error) => {
    return { type: ResourceConstants.RESOURCESTATUSCHANGE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(statusData));
    return resourceService.resourceStatusChange(statusData,id).then(
      (resource) => {
        toast.success("Resource deleted");
        dispatch(success(resource));
        return resource;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
        return false;
      }
    );
  };
};

//EnumData
const getEnumData = (id) => {
  const request = (enumData) => {
    return { type: ResourceConstants.ENUM_REQUEST, enumData };
  };
  const success = (enumData) => {
    return { type: ResourceConstants.ENUM_SUCCESS, enumData };
  };
  const failure = (error) => {
    return { type: ResourceConstants.ENUM_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    resourceService.getEnum().then(
      (enumData) => {
        dispatch(success(enumData));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
};

export const ResourceActions = {
  getEnumData,
  createUser,
  createResource,
  updateResourceStatus,
  updateResource
};
